import type {
  GetElecMarketMonitoringDailyProdChartParams,
  GetElecMarketMonitoringDailyProdChartResponse,
  GetElecMarketMonitoringDayAheadIndicatorsResponse,
  GetElecMarketMonitoringFutureProdChartParams,
  GetElecMarketMonitoringFutureProdChartResponse,
  GetElecMarketMonitoringFutureProdDailyParams,
  GetElecMarketMonitoringFutureProdDailyResponse,
  GetElecMarketMonitoringHourlyProdsParams,
  GetElecMarketMonitoringHourlyProdsResponse,
  GetElecMarketMonitoringIndicatorsParams,
  GetElecMarketMonitoringIndicatorsResponse,
} from "$/lib/types/api/market-monitoring/electricity.types";
import { restApiClient } from "../restApiClient";

export const getElecIndicators = async (
  params: GetElecMarketMonitoringIndicatorsParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec/indicators")
    .query({ ...params })
    .get<GetElecMarketMonitoringIndicatorsResponse>();
};

export const getElecDailyProductsChart = async (
  params: GetElecMarketMonitoringDailyProdChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec/daily-products-chart")
    .query({ ...params })
    .get<GetElecMarketMonitoringDailyProdChartResponse>();
};

export const getElecDayAheadPrices = async (params: { date: string }) => {
  return restApiClient
    .url("/market-monitoring/elec/day-ahead-indicators")
    .query({ ...params })
    .get<GetElecMarketMonitoringDayAheadIndicatorsResponse>();
};

export const getElecFutureProductsChart = async (
  params: GetElecMarketMonitoringFutureProdChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec/future-products-chart")
    .query({ ...params })
    .get<GetElecMarketMonitoringFutureProdChartResponse>();
};

export const getElecFutureProductsDailyIndicators = async (
  params: GetElecMarketMonitoringFutureProdDailyParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec/future-products-daily")
    .query({ ...params })
    .get<GetElecMarketMonitoringFutureProdDailyResponse>();
};

export const getElecHourlyProducts = async (
  params: GetElecMarketMonitoringHourlyProdsParams,
) => {
  return restApiClient
    .url("/market-monitoring/elec/elec-hourly-products")
    .query({ ...params })
    .get<GetElecMarketMonitoringHourlyProdsResponse>();
};
